import { Container, Title, Text, Stack, Button, Group, Card } from '@mantine/core'
import { IconArrowRight, IconRocket, IconDeviceMobile } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'

export function HelpPage() {
    const navigate = useNavigate()

    return (
        <Container size="md" py="xl">
            <Stack gap="xl">
                <div>
                    <Title order={1} size="h1" mb="md">Help & Support</Title>
                    <Text size="lg" c="dimmed">
                        Everything you need to know about using Spotter effectively.
                    </Text>
                </div>

                <Group gap="lg" grow>
                    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ cursor: 'pointer' }} onClick={() => navigate('/help/getting-started')}>
                        <Group gap="md" mb="md">
                            <IconRocket size={32} color="var(--mantine-color-blue-6)" />
                            <div>
                                <Title order={3} size="h3">Getting Started</Title>
                                <Text size="sm" c="dimmed">Learn the basics of Spotter</Text>
                            </div>
                        </Group>
                        <Text size="sm" mb="md">
                            New to Spotter? Start here to learn how to create spottings, use location services, and get the most out of the app.
                        </Text>
                        <Button variant="light" rightSection={<IconArrowRight size={16} />} fullWidth>
                            Get Started
                        </Button>
                    </Card>

                    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ cursor: 'pointer' }} onClick={() => navigate('/help/add-to-home-screen')}>
                        <Group gap="md" mb="md">
                            <IconDeviceMobile size={32} color="var(--mantine-color-green-6)" />
                            <div>
                                <Title order={3} size="h3">Install App</Title>
                                <Text size="sm" c="dimmed">Add to your home screen</Text>
                            </div>
                        </Group>
                        <Text size="sm" mb="md">
                            Get the best Spotter experience by installing the app on your device. Works on iPhone, Android, and desktop.
                        </Text>
                        <Button variant="light" rightSection={<IconArrowRight size={16} />} fullWidth>
                            Install Guide
                        </Button>
                    </Card>
                </Group>

                <Stack gap="md">
                    <Title order={2} size="h2">Frequently Asked Questions</Title>

                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Title order={4} size="h4" mb="sm">How do I create a spotting?</Title>
                        <Text size="sm">
                            Click anywhere on the map or use the "Create Spotting at my Location" button. You'll need to sign in first to contribute spottings.
                        </Text>
                    </Card>

                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Title order={4} size="h4" mb="sm">Why isn't my location working?</Title>
                        <Text size="sm">
                            Make sure you've allowed location access in your browser settings. On iOS Safari, you may need to tap "Use My Location" to trigger the permission prompt.
                        </Text>
                    </Card>

                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Title order={4} size="h4" mb="sm">Can I use Spotter without signing in?</Title>
                        <Text size="sm">
                            Yes! You can browse and view all spottings without an account. You only need to sign in to create new spottings.
                        </Text>
                    </Card>

                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Title order={4} size="h4" mb="sm">How do I edit or delete my spottings?</Title>
                        <Text size="sm">
                            Click on any of your spottings in the list or on the map, then use the edit or delete buttons in the spotting details.
                        </Text>
                    </Card>
                </Stack>
            </Stack>
        </Container>
    )
} 